module.exports = __webpack_public_path__ + "cda6f7c065e4e128d442778f53c2f198.svg";